import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { Box, Grid, Link } from '@mui/material';
import { ReactNode } from 'react';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { Item, WsColors, WsTitleBanner, WsTypoColors, WsTypography } from 'wisestep-base';

import SettingsMenu from '../../appsettings/components/SettingsMenu';

type IAppSettingsLayoutProps = {
  children: ReactNode;
  getSelectedOption?: (option: number) => void;
  getSelectedSubOption?: (subOption: number) => void;
};

const MyPlanLayout = ({
  children,
  getSelectedOption,
  getSelectedSubOption,
}: IAppSettingsLayoutProps) => {
  const navigate = useNavigate();
  const options = [
    {
      label: 'My Plan',
      icon: <ReceiptOutlinedIcon sx={{ color: WsColors.TheBlues500 }} />,
      url: '/app-settings/plan-details',
    },
    {
      label: 'Invoices',
      icon: <ReceiptLongIcon sx={{ color: WsColors.TheBlues500 }} />,
      url: '/app-settings/my-invoices',
    },
    {
      label: 'FAQs',
      icon: <MdOutlineHelpOutline size={25} color={WsColors.TheBlues500} />,
      url: '/help-and-knowledge/faq-payment-integration',
    },
    {
      label: 'Pricing',
      icon: <LocalAtmIcon sx={{ color: WsColors.TheBlues500 }} />,
      url: '/plan/purchase',
    },
  ];

  return (
    <Grid container columnSpacing={1.5} rowSpacing={4}>
      <Grid item xs={12}>
        <WsTitleBanner title="My Plan" backButton goBack={() => navigate('/home')} />
      </Grid>
      <Grid item xs={3}>
        <Box>
          <SettingsMenu
            options={options}
            getSelectedOption={getSelectedOption}
            getSelectedSubOption={getSelectedSubOption}
          />
        </Box>
        <Box sx={{ bgcolor: WsColors.White, mt: '12px !important' }} textAlign="center">
          <Item>
            <WsTypography bold color={WsTypoColors.SECONDARY}>
              Need help with the Plan ?
            </WsTypography>
            <WsTypography bold color={WsTypoColors.SECONDARY}>
              Please let our support team answer you
            </WsTypography>
            <Box sx={{ mt: '4px !important' }}>
              <WsTypography bold color={WsTypoColors.SECONDARY} display="inline">
                Contact us at
              </WsTypography>
              <Link ml={0.6} href="mailto:sales@wisestep-inc.com">
                sales@wisestep-inc.com
              </Link>
            </Box>
          </Item>
        </Box>
      </Grid>

      <Grid item xs={9}>
        <Item sx={{ backgroundColor: WsColors.White, height: '100%' }}>{children}</Item>
      </Grid>
    </Grid>
  );
};

export default MyPlanLayout;
